import React, { useState, useRef, useContext } from 'react'; // 1. Add useContext
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import destinations from '../../Data/SightseeingDestinations.json';
import { useNavigate } from 'react-router-dom';
import { LandingContext } from '../Profile/LandingContext'; // 2. Import the context
import DefaultData from '../../CompanyData/DefaultData';

const SearchSightSeeingPanel = () => {
    const navigate = useNavigate();
    const landingData = useContext(LandingContext);
    const [destination, setDestination] = useState('');
    const [destinationCode, setDestinationCode] = useState(0);
    const [travelDate, setTravelDate] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return currentDate;
    });
    const [adults, setAdults] = useState(1);
    const [kids, setKids] = useState(0);
    const [errors, setErrors] = useState({});
    const validate = () => {
        let temp = {};
        temp.destination = destination === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "destination": destination,
                "destinationCode": destinationCode,
                "adults": adults,
                "kids": kids,
                "travelDate": moment(travelDate).format('YYYY-MM-DD'),
                "currencyCode": DefaultData?.DEFAULTCURRENCY,
                "companyId": DefaultData?.DEFAULTCOMPANYID
            }
            navigate('/sightseeing/products/' + destinationCode + "/" + destination + "/" + adults + "/" + kids + "/" + moment(travelDate).format('YYYY-MM-DD'), { state: { searchQuery } });
        }
    }
    const handleIncreaseAdults = (e) => { e.stopPropagation(); setAdults(parseFloat(adults + 1)) }
    const handleDecreaseAdults = (e) => { e.stopPropagation(); if (adults !== 1) { setAdults(parseFloat(adults - 1)) } }
    const handleIncreaseKids = (e) => { e.stopPropagation(); setKids(parseFloat(kids + 1)) }
    const handleDecreaseKids = (e) => { e.stopPropagation(); if (kids !== 0) { setKids(parseFloat(kids - 1)) } }
    const handleDepartureDate = (date) => { const selectedDate = date[0]; setTravelDate(selectedDate); }
    const [departureResults, setDepartureResults] = useState([]);
    const inputDRef = useRef(null);
    const handleDepartureAirportSearch = (e) => {
        const value = e.target.value;
        setDestination(value);
        if (value.length > 0) {
            const filteredAirports = destinations.filter(airport => airport.destinationName.toLowerCase().includes(value.toLowerCase())).slice(0, 10);
            setDepartureResults(filteredAirports);
        } else { setDepartureResults([]); }
    };
    const handleDepartureAirportClick = (e) => {
        let filteredAirports = destinations.filter(function (p) { return true; }).slice(0, 10);
        setDepartureResults(filteredAirports);
        inputDRef.current.select();
    };
    const handleDepartureSelect = (data) => {
        setDestinationCode(data.parentId);
        setDestination(data.destinationName)
        setDepartureResults([]);
    }

    const searchButtonStyle = {
        backgroundColor: DefaultData.THEMECOLOR1, // Fallback to a default orange
        borderColor: DefaultData.THEMECOLOR1,
    };

    return (

        <div className="sightseeing-search-bar">
            <div className="row g-3 align-items-end">

                {/* Destination Column */}
                <div className="col-lg">
                    <label htmlFor="destination-input" className="form-label">DESTINATION</label>
                    <div className="form-icon position-relative">
                        <input id="destination-input" className="form-control" type="text" placeholder="Search Destination Ex: Dubai" value={destination} onChange={handleDepartureAirportSearch} onClick={handleDepartureAirportClick} onFocus={handleDepartureAirportClick} ref={inputDRef} autoComplete="off" />
                        <i className="ri-map-pin-line" />
                    </div>
                    {errors.destination === false ? (<div className="validationerror text-danger">Please select destination</div>) : null}
                    {departureResults.length > 0 && (
                        <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px", maxWidth: "400px" }}>
                            {departureResults.map((city) => (
                                <li className="locationListVideoItem" style={{ textAlign: "Left" }} key={city.destinationId} onClick={() => handleDepartureSelect(city)}>
                                    {city.destinationName}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Travel Date Column */}
                <div className="col-lg-3">
                    <label htmlFor="travel-date" className="form-label">TRAVEL DATE</label>
                    <div className="input-group">
                        <Flatpickr id="travel-date" className="form-control" value={travelDate} onChange={handleDepartureDate} options={{ dateFormat: "d M Y", minDate: "today", disable: [new Date()] }} />
                        <div className="input-group-text bg-primary border-primary text-white">
                            <i className="ri-calendar-2-line"></i>
                        </div>
                    </div>
                </div>

                {/* Travellers Column */}
                <div className="col-lg-4">
                    <label htmlFor="travellers-dropdown" className="form-label">TRAVELLERS</label>
                    <div className="dropdown" data-bs-auto-close="outside">
                        <div id="travellers-dropdown" className="form-control w-100 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {adults + " Adults, " + kids + " Kids"}
                        </div>
                        <div className="dropdown-menu p-3" aria-labelledby="travellers-dropdown">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Adults (12+ years)</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseAdults}>–</button>
                                    <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={adults} />
                                    <button type="button" className="plus" onClick={handleIncreaseAdults}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Kids (Below 12Years)</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseKids}>–</button>
                                    <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={kids} />
                                    <button type="button" className="plus" onClick={handleIncreaseKids}>+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Search Button Column */}
                <div className="col-lg-auto">
                    {/* KEY CHANGE: Applying "btn-search" class */}
                    <button
                        type="button"
                        className="btn btn-search"
                        onClick={handleSearch}
                        style={searchButtonStyle}
                    >
                        SEARCH
                    </button>
                </div>

            </div>
        </div>
    );
};

export default SearchSightSeeingPanel;